import { useState, useEffect } from 'react';

/**
 * Dead simple media query hook.
 * Returns true when the viewport matches the given query string.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Convenience: true when viewport <= 768px */
export function useMobile(): boolean {
  return useMediaQuery('(max-width: 768px)');
}

/** Convenience: true when viewport <= 1024px */
export function useTablet(): boolean {
  return useMediaQuery('(max-width: 1024px)');
}
